module.exports = __webpack_public_path__ + "fonts/tooltip_close.03de1f1c705b7c21292c763921b47431.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/login/tooltip_close.png
// module id = 258
// module chunks = 9